import type { WriteDebugLogFn } from '@wix/cli-debug-log';
import { pathExists, readJson, writeJson } from '@wix/cli-fs';
import { getAppConfigPath, appConfigSchema } from '@wix/cli-app-definitions';
import type { AppConfig } from '@wix/cli-app-definitions';

export async function readAppConfig(
  projectFolder: string,
  writeDebugLog?: WriteDebugLogFn
) {
  const configPath = getAppConfigPath(projectFolder);
  const isConfigExist = await pathExists(configPath);

  if (!isConfigExist) {
    return null;
  }

  try {
    const json = await readJson(configPath);
    const appConfig = await appConfigSchema.safeParseAsync(json);

    if (!appConfig.success) {
      return null;
    }

    return appConfig.data;
  } catch (e) {
    writeDebugLog?.(e);
    return null;
  }
}

export async function saveAppConfig(projectFolder: string, config: AppConfig) {
  const currentConfig = (await readAppConfig(projectFolder)) ?? {};
  const newConfig = {
    ...currentConfig,
    ...config,
  };

  await writeJson(getAppConfigPath(projectFolder), newConfig);
}
